import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f1229aa")

_pushScopeId("data-v-3f1229aa")
const _hoisted_1 = { class: "toc_ui__photoView_swiperModel" }
const _hoisted_2 = { class: "toc_ui__photoView_bannerBox" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_swiperComponent = _resolveComponent("swiperComponent")

  return (_openBlock(), _createBlock("div", {
    class: "toc_ui__photoView_main",
    style: {height:_ctx.state.clientHeight + 'px'}
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_swiperComponent, {
          imgList: _ctx.swiperPhotoList,
          initialSlide: _ctx.initialSlide,
          imgListLen: _ctx.imgListLen,
          tabName: _ctx.tabName,
          noImg: _ctx.noImg,
          onSlideChange: _ctx.slideChange
        }, null, 8, ["imgList", "initialSlide", "imgListLen", "tabName", "noImg", "onSlideChange"])
      ])
    ])
  ], 4))
})